<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Contacts</h1>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="sharedService.changeRoute('home')"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <div
      class="action-bar mt-3 d-flex justify-content-between align-items-center bg-dark-subtle rounded-3"
    >
      <!-- Legend sits next to the Refresh Table button on the left side of
           the action bar. -->
      <div class="left-actions d-flex align-items-center gap-3">
        <button
          class="btn modern-btn blue-btn btn-sm"
          (click)="refreshTableDataClick()"
        >
          <i class="fa-solid fa-rotate me-2"></i>Refresh Table
        </button>
        <span class="legend">
          <i class="fa-solid fa-square" style="color: coral"></i>
          <span class="text-muted">Customer</span>
        </span>
        <span class="legend">
          <i class="fa-solid fa-square" style="color: lightskyblue"></i>
          <span class="text-muted">Vendor</span>
        </span>
      </div>

      <div class="right-actions d-flex gap-2">
        <div class="btn-group" dropdown container="body" placement="bottom right">
          <button
            dropdownToggle
            type="button"
            class="btn modern-btn grey-btn btn-sm dropdown-toggle"
          >
            New Transaction
          </button>
          <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-dark modern-dropdown shadow-lg dropdown-menu-end"
          >
            <li class="disabled">
              <a class="dropdown-item disabled">Customers</a>
            </li>
            <li>
              <a class="dropdown-item" (click)="createNewCustomerContactClick()"
                ><i class="fa-solid fa-plus me-2"></i>Create Customer</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                (click)="sharedService.openFilePicker('Customer')"
                ><i class="fa-solid fa-file-import me-2"></i>Import Customers
                From File</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                (click)="downloadImportTemplate('Customer')"
                ><i class="fa-solid fa-download me-2"></i>Download Customer
                Template</a
              >
            </li>

            <li class="divider dropdown-divider"></li>

            <li class="disabled">
              <a class="dropdown-item disabled">Vendors</a>
            </li>
            <li>
              <a class="dropdown-item" (click)="createNewVendorContactClick()"
                ><i class="fa-solid fa-plus me-2"></i>Create Vendor</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                (click)="sharedService.openFilePicker('Vendor')"
                ><i class="fa-solid fa-file-import me-2"></i>Import Vendors From
                File</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                (click)="downloadImportTemplate('Vendor')"
                ><i class="fa-solid fa-download me-2"></i>Download Vendor
                Template</a
              >
            </li>

            <li class="divider dropdown-divider"></li>
            <li>
              <a
                class="dropdown-item"
                (click)="saveCurrentTablePreferencesClick()"
                ><i class="fa-solid fa-floppy-disk me-2"></i>Save Table
                Settings</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body p-0 d-flex flex-column flex-grow-1">
    <!-- Need to open the file picker -->
    <input type="file" id="fileInput" style="display: none" />
    <ag-grid-angular
      #grid
      id="dispo_list"
      class="modern-grid flex-grow-1"
      style="width: 100%; height: 100%"
      
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="contacts"
      [preventDefaultOnContextMenu]="true"
      (gridReady)="onGridReady($event)"
      (cellContextMenu)="onCellContextMenu($event)"
      [animateRows]="true"
      [components]="components"
      [enableBrowserTooltips]="true"
      [pagination]="true"
      [paginationPageSize]="sharedService.default_pagination_page_size"
      [paginationPageSizeSelector]="[20, 50, 100, 500]"
      (filterChanged)="storeCurrentSessionFilters()"
      (columnPinned)="storeCurrentSessionColumnConfig()"
      (columnResized)="storeCurrentSessionColumnConfig()"
      (columnMoved)="storeCurrentSessionColumnConfig()"
      (sortChanged)="storeCurrentSessionColumnConfig()"
    ></ag-grid-angular>
  </div>
</div>

<!-- Added for the right click "Copy" function -->
@if ((menuState$ | async)?.showMenu) {
  <div
    class="custom-context-menu"
    [style.top.px]="(menuState$ | async)?.menuTop"
    [style.left.px]="(menuState$ | async)?.menuLeft"
    (click)="copyCellValue()"
    (mouseenter)="onMenuMouseEnter()"
    (mouseleave)="onMenuMouseLeave()"
  >
    <i class="fa-solid fa-copy me-2"></i> Copy
  </div>
}
